var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-invalid-feedback',{class:{ 'permaHeight': _vm.keepHeight }},[_vm._v(" "+_vm._s(_vm.vc.errors[0])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }